import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { GeneralService } from "../../../services/general.service";
import { Injectable } from "@angular/core";
import { ISavedDataList } from "../interfaces/ISavedDataList";
import { Page } from "../../../model/page";

@Injectable()
export class SavedDataService extends GeneralService {
  static MODE_SV1 = "sv1";
  static SV1_URL = "replenishment-order";
  static SV1_TITLE = "Replenishment";
  static MODE_SV2 = "sv2";
  static SV2_URL = "consumption-order";
  static SV2_TITLE = "Consumption";
  static MODE_SV3 = "sv3";
  static SV3_URL = "receiving-order";
  static SV3_TITLE = "Receiving";

  constructor(protected http: HttpClient) {
    super(http);
  }

  getById(id: number): Observable<any> {
    if (id === 0) {
      return Observable.of(this.initialize());
    }

    const url = `${this.apiUrl}/order-entry-system/saved-data/view?id=${id}`;
    return this.http.get(url).catch(this.handleError);
  }

  save(model: any, isCreate: boolean): Observable<any> {
    const url = `${this.apiUrl}/order-entry-system/saved-data/new`;
    return this.http.post(url, model).catch(this.handleError);
  }

  public create(
    savedData: any,
    mode: string,
    validate = false
  ): Observable<any> {
    const url = `${this.apiUrl}/saved-data/create`;
    return this.http.post(url, {
      savedData: savedData,
      mode: mode,
      validate: validate ? 1 : 0,
    });
  }

  public update(
    savedData: any,
    mode: string,
    invalidScan = false
  ): Observable<any> {
    const url = `${this.apiUrl}/saved-data/update`;
    return this.http.put(url, {
      savedData: savedData,
      mode: mode,
      invalidScan: invalidScan ? 1 : 0,
    });
  }

  public getDataList(page: Page): Observable<any> {
    const url = "/saved-data";
    return this.getRestList(page, url);
  }

  public getItems(mode: string): Observable<any> {
    return this.http.get(this.apiUrl + "/saved-data", {
      params: { mode: mode },
    });
  }

  public loadFromInvoice(
    invoiceNumbers: string,
    poNumber: string,
    jobNumber: string,
    mode: string
  ): Observable<any> {
    const url = `${this.apiUrl}/saved-data/load-from-invoice`;
    return this.http.post(url, {
      invoiceNumbers: invoiceNumbers,
      poNumber: poNumber,
      jobNumber: jobNumber,
      mode: mode,
    });
  }

  public loadFromTransfer(
    transferNumbers: string,
    poNumber: string,
    jobNumber: string,
    mode: string
  ): Observable<any> {
    const url = `${this.apiUrl}/saved-data/load-from-transfer`;
    return this.http.post(url, {
      transferNumbers: transferNumbers,
      poNumber: poNumber,
      jobNumber: jobNumber,
      mode: mode,
    });
  }

  public preload(): Observable<any> {
    const url = `${this.apiUrl}/saved-data/preload`;
    return this.http.get(url);
  }

  public autoOrder(poNumber: string, jobNumber: string): Observable<any> {
    const url = `${this.apiUrl}/saved-data/auto-order`;
    return this.http.post(url, { poNumber: poNumber, jobNumber: jobNumber });
  }

  delete(IDs: Array<any>, mode: string): Observable<any> {
    const url = `${this.apiUrl}/saved-data/delete`;
    return this.http.post(url, { IDs: IDs, mode: mode });
  }

  export(preferences, page = null): Observable<any> {
    const url = "/saved-data/export";
    return super.getExportXlsData(url, preferences, page);
  }

  generateXls(xlsData: HttpResponse<Blob>, fileName: string) {
    super.generateXls(xlsData, fileName);
  }

  submit(IDs: Array<any>, mode: string, quote: boolean): Observable<any> {
    const url = `${this.apiUrl}/saved-data/submit`;
    return this.http.post(url, { IDs: IDs, mode: mode, quote: quote });
  }

  public checkRecentOrders(MD1_IDs: Array<any>): Observable<any> {
    const url = `${this.apiUrl}/saved-data/check-recent-orders`;
    return this.http.post(url, { MD1_IDs: MD1_IDs });
  }

  public showMatches(searchItem: any, mode: string): Observable<any> {
    const url = `${this.apiUrl}/saved-data/find-match`;
    return this.http.post(url, { scan: searchItem, mode: mode });
  }

  public initialize() {
    return {};
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/saved-data.service.ts